<template>
	<div class="quote-tendency">
		<div class="quote-tendency-info">
			<span class="close-price" :style="formatValueStyleFn(stockQuoteData.change)">
				{{ formatClosePrice() }}
			</span>
			<span class="curr-unit" :style="formatValueStyleFn(stockQuoteData.change)">{{ currUnitTips }} </span>
			<SvgIcons
				name="arrow_up"
				class="arrow_up-icon"
				:class="[stockQuoteData.change < 0 ? 'animate' : '']"
				:style="formatValueStyleFn(stockQuoteData.change)"
			/>

			<span class="trend-number" :style="formatValueStyleFn(stockQuoteData.change)">
				{{ stockQuoteData.change }}</span
			>
			<span class="trend-number" :style="formatValueStyleFn(stockQuoteData.changePct)">{{
				stockQuoteData.changePct?.toFixed(2) + '%'
			}}</span>
		</div>
		<p class="deadline">{{ formatDateFn(stockQuoteData) }}</p>
	</div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { convertNumberToCNUnit } from '@/utils/api';
import { useStockVO } from '@rebuild/hooks/useStockVO';
import i18n, { ZH } from '@/locales';
import dayjs from 'dayjs';
import { useStore } from '@/utils/vue-api';

const props = defineProps({
	stockQuoteData: {
		type: Object,
		default: () => ({})
	},
	isRealTime: {
		type: Boolean,
		default: false
	}
});

const store = useStore();
const currUnitTips = computed(() => store.getters.getCurrUnitTips);

const { proxy } = getCurrentInstance();
const { isUSStock } = useStockVO();

const formatClosePrice = () => {
	const { value } = convertNumberToCNUnit(props.stockQuoteData.closePrice);
	return value;
};

const formatDateFn = data => {
	const { tradingDay, time } = data;
	if (props.isRealTime) return time;
	const formatValue = tradingDay || dayjs().format('YYYY-MM-DD HH:mm');
	return `${proxy.$t('enterprise.common-a.until')} ${formatValue} （${proxy.$t(
		isUSStock.value ? 'enterprise.EDT' : 'enterprise.UTC'
	)}）`;
};

const isCn = computed(() => i18n.locale === ZH);

const formatValueStyleFn = value => {
	const up = isCn.value ? '#fa4646' : '#30bf54';
	const down = isCn.value ? '#30bf54' : '#fa4646';
	return {
		color: value > 0 ? up : down
	};
};
</script>

<style lang="less" scoped>
.quote-tendency {
	&-info {
		.close-price {
			font-size: 36px;

			font-weight: 500;
			line-height: 44px; /* 122.222% */
		}
		.curr-unit {
			font-size: 20px;

			font-weight: 500;
			line-height: 44px;
		}
		.trend-number {
			font-size: 14px;

			font-weight: 400;
			line-height: 18px; /* 128.571% */
			margin-left: 8px;
		}
		.arrow_up-icon {
			font-size: 24px;
		}
	}
}

.animate {
	transform: rotate(-180deg);
}

.deadline {
	color: #86909c;

	font-size: 12px;

	font-weight: 400;
	line-height: 16px; /* 133.333% */
}
</style>
